import { useContext, useEffect, useState } from 'react';
import style from './VendorSalesSettlement.module.css';
import { requester } from 'App';
import {
    combineDuplicates,
    filterDataByThisMonth,
    filterDataByThisWeek,
    filterDataByThisYear,
    filterDataByToday,
    getDailySales,
    getTotalAmount,
} from 'routes/vendorRe/commonFn/vendorPurchaseOrder';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import P from 'routes/vendorRe/containers/commons/P';
import LineChart from 'routes/vendorRe/components/LineChart';
import SettlementAmount from './settlementComp/SettlementAmount';
import SettlementStatus from './settlementComp/SettlementStatus';
import SettlementBest from './settlementComp/SettlementBest';
import SettlementStat from './settlementComp/SettlementStat';
import Center from 'layouts/wrapper/Center';
import { AuthContext } from 'providers/AuthProvider';
import VendorCalc from 'routes/vendorRe/pages/VendorCalc';

function VendorSalesSettlement() {
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const { userName } = useContext(AuthContext);


    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            let data = {};
            requester.getVendorTotalAmount(data, result => {
                if (result.data) {
                    setTotalAmount(result.data.amount);
                }
            });
        }
    }, [isMounted]);

    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild width={"95%"}>
                        <Center width={'100%'} textAlign={'left'}>
                            <P weight={'bold'} size={40}>
                                정산관리
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={"95%"}>
                        <HorizontalFlex
                            gap={20}
                        >
                            <FlexChild>
                                <HorizontalFlex gap={20} alignItems={'flex-start'}>
                                    <FlexChild> 
                                        {/* 매출 현황 */}
                                        <SettlementStatus />
                                    </FlexChild>
                                    <FlexChild>
                                        <VendorCalc web />
                                    </FlexChild>



                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild width={"95%"}>
                        {/* 주간 판매량 BEST 3 */}
                        <SettlementBest />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default VendorSalesSettlement;
